import { normalizedEmailField } from '@/validation-schema/email-field';
import * as yup from 'yup';

export const passwordResetSchema = yup.object({
  email: normalizedEmailField(),
});
